import { styled } from "styled-components";

export const PromoCardWrappler = styled.div`
  cursor: pointer;
  flex: 1;
`;
